<main class="observer-map-page">
  <app-map-toolbar />

  <section class="map-container" [class.map-container--list-open]="facade.isEntityListOpen()">
    <div class="map-shell">
      <app-observer-map-canvas />
      <app-drone-details-panel />
      <app-observer-photo-modal />
    </div>

    @if (facade.isEntityListOpen()) {
      <app-observer-entity-list id="entity-list-panel" />
    }
  </section>
</main>
